import { useState, useRef, useEffect } from "react";
import { href, useLocation } from "react-router-dom";

const DIGITAL_HEALTH_MENU = [
  {
    id: "journey",
    label: "Start Care Journey",
    href: "/carejourney",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 12h18M3 6h18M3 18h12" />
      </svg>
    ),
  },
  {
    id: "carenavigator",
    label: "Care Navigator",
    href: "/care-navigator",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
      </svg>
    ),
  },
  {
    id: "findrightcare",
    label: "Find Right Program",
    href: "/findprogram",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
      </svg>
    ),
  },
  {
    id: "bookappointment",
    label: "Book Appointment",
    href: "/book-an-appointment",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    id: "healthassessment",
    label: "Health Assessment",
    href: "/health-assessment",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
      </svg>
    ),
  },
  {
    id: "symptomchecker",
    label: "Symptom Checker",
    href: "/symptom-checker",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <line x1="11" y1="8" x2="11" y2="14" />
        <line x1="8" y1="11" x2="14" y2="11" />
      </svg>
    ),
  },
];

export default function DigitalHealthFAB() {
  const [open, setOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false); // ✅ properly defined
  const wrapRef = useRef(null);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  // ✅ Pulse tooltip every 5s on home page (matches HealthChatBot pattern)
  
  // useEffect(() => {
  //   let scrollTimer;
  //   const handleScroll = () => {
  //     setShowTooltip(false); // hide tooltip on scroll
  //     clearTimeout(scrollTimer);
  //     scrollTimer = setTimeout(() => {
  //       setShowTooltip(true);
  //       setTimeout(() => {
  //         setShowTooltip(false);
  //       }, 3000);
  //     }, 800); //user stopped scrolling for 800ms, show tooltip for 3s
  //   }
  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll)
  //     clearInterval(scrollTimer);
  //   };
  //   // if (!isHomePage) return;
  //   // const interval = setInterval(() => setShowTooltip((p) => !p), 1000);
  //   // return () => clearInterval(interval);
  // }, []);

useEffect(() => {
  let scrollTimer;
  let blinkInterval;

  const startBlinking = () => {
    // initial show
    setShowTooltip(true);

    blinkInterval = setInterval(() => {
      setShowTooltip((prev) => !prev);
    }, 1000); 
  };

  const stopBlinking = () => {
    clearInterval(blinkInterval);
    setShowTooltip(false);
  };

  const handleScroll = () => {
    // stop while scrolling
    stopBlinking();

    clearTimeout(scrollTimer);

    // restart after user stops scrolling for 1 sec
    scrollTimer = setTimeout(() => {
      startBlinking();
    }, 1000);
  };

  // initial start after 1 sec
  scrollTimer = setTimeout(() => {
    startBlinking();
  }, 1000);

  window.addEventListener("scroll", handleScroll, { passive: true });

  return () => {
    window.removeEventListener("scroll", handleScroll);
    clearTimeout(scrollTimer);
    clearInterval(blinkInterval);
  };
}, []);

  // ✅ Close panel when clicking outside
  useEffect(() => {
    const onOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onOutside);
    return () => document.removeEventListener("mousedown", onOutside);
  }, []);

  return (
    <div
      ref={wrapRef}
      className={`ava-fab-wrap${open ? " ava-fab-wrap--open" : ""}`}
      onMouseEnter={() => setShowTooltip(true)}   // ✅ show on hover
      onMouseLeave={() => setShowTooltip(false)}  // ✅ hide on leave
    >
      {/* Pulse rings */}
      <span className="ava-fab-ring" aria-hidden="true" />
      <span className="ava-fab-ring ava-fab-ring--2" aria-hidden="true" />

      {/* Tab button */}
      <button
        className={`ava-fab-btn${open ? " ava-fab-btn--open" : ""}`}
        onClick={() => {
          setOpen((v) => !v);
          setShowTooltip(false); // ✅ hide tooltip when panel opens
        }}
        aria-label="Open Digital Health menu"
        aria-expanded={open}
        aria-haspopup="true"
      >
        <div className="ava-fab-arrow-wrap">
          <span className={`ava-fab-arrow${open ? " open" : ""}`}>
            <img src="/images/right.svg" className="w-5 h-5" />
          </span>
        </div>
      </button>

      {/* ✅ Tooltip — controlled fully by JS via showTooltip state */}
      {/* {!open && (
        <span
          className={`ava-fab-tooltip${showTooltip ? " ava-fab-tooltip--visible" : ""}`}
          role="tooltip"
        >
          Digital Health
        </span>
      )} */}

      {/* Slide-out panel */}
      <nav
        className="ava-fab-panel"
        role="menu"
        aria-label="Digital Health navigation"
      >
        <div className="ava-fab-panel__header">
          <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4l2 2" />
          </svg>
          <span className="ava-fab-panel__title">For Patient</span>
        </div>

        {DIGITAL_HEALTH_MENU.map((item, i) => (
          <a
            key={item.id}
            href={item.href}
            className="ava-fab-panel__item"
            role="menuitem"
            style={
              open
                ? { animation: `ava-fab-item-in 0.3s ease ${i * 0.05 + 0.04}s both` }
                : { opacity: 0 }
            }
          >
            <span className="ava-fab-panel__icon" aria-hidden="true">
              {item.icon}
            </span>
            <span className="ava-fab-panel__label">{item.label}</span>
            <span className="ava-fab-panel__chevron" aria-hidden="true">›</span>
          </a>
        ))}
      </nav>
    </div>
  );
}